<template lang="pug">
div
  el-row(v-if="!isBeneficiario")
    el-row.marginTop
      .margem
        el-col(:span="12")
          app-display(
            label="Tipo de cadastro:",
            :content="tipo",
          )
        el-col(:span="12")
          app-display(
            label="Data de cadastro:",
            :content="this.dataCadastro",
          )
        el-col(:span="12",v-if="dataRetificacao")
          app-display(
            label="Data de retifição:",
            :content="this.dataCadastro",
          )
  el-row
    app-divider(label="Qualificação", v-if="qualificacao")
  el-row.marginTop
    el-col(v-if="qualificacao", :span="24")
      .margem
        app-display(
          :label="labelQualificacao.area",
          :content="formatterDecimal(qualificacao.area) + ' hectare(s)'",
        )
        app-display(
          v-if="qualificacao.municipio"
          label="Município:",
          :content="qualificacao.municipio.nome"
        )
        app-display(
          label="Qual a renda familiar?",
          :content="renda",
        )
        app-display(
          :label="labelQualificacao.brasileiroNatoNaturalizado",
          :content="qualificacao.brasileiroNatoNaturalizado ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.cargoPublico",
          :content="qualificacao.cargoPublico ? 'Sim' : 'Não'",
        )
        app-display(
          v-if="qualificacao.cargoPublico"
          :label="labelQualificacao.dataAquisicaoImovel",
          :content="formatDate(qualificacao.dataAquisicaoImovel)",
        )
        app-display(
          v-if="qualificacao.cargoPublico"
          :label="labelQualificacao.dataPosseCargopublico",
          :content="formatDate(qualificacao.dataPosseCargopublico)",
        )
        app-display(
          :label="labelQualificacao.desintrusado",
          :content="qualificacao.desintrusado ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.contestacaoTerceiros",
          :content="qualificacao.contestacaoTerceiros ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.possuiImovelRuralTitulado",
          :content="qualificacao.possuiImovelRuralTitulado ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.ocupaImovel",
          :content="qualificacao.ocupaImovel ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.beneficiarioReformaAgraria",
          :content="qualificacao.beneficiarioReformaAgraria ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.cunhoRecreativo",
          :content="qualificacao.cunhoRecreativo ? 'Sim' : 'Não'",
        )
        app-display(
          v-if="qualificacao.cunhoRecreativo"
          :label="labelQualificacao.moradiaHabitual",
          :content="qualificacao.moradiaHabitual ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.trabalhoEscravo",
          :content="qualificacao.trabalhoEscravo ? 'Sim' : 'Não'",
        )
        app-display(
          :label="labelQualificacao.ocupantePrimitivo",
          :content="qualificacao.ocupantePrimitivo ? 'Sim' : 'Não'",
        )
        app-display(
          v-if="qualificacao.ocupantePrimitivo"
          :label="labelQualificacao.dataOcupacaoPrimitiva",
          :content="formatDate(qualificacao.dataOcupacaoPrimitiva)",
        )
        app-display(
          v-else
          :label="labelQualificacao.dataOcupacaoPrimitiva",
          :content="formatDate(qualificacao.dataOcupacaoPrimitiva)",
        )
        el-row(:gutter="30" v-if="qualificacao.transmitentes.length > 0")
          el-table.table(
            :data='qualificacao.transmitentes',
            stripe,
            element-loading-text="Carregando..."
          )
            template(slot="empty")
                | Não há registros.
            el-table-column(
              prop='nome',
              label='Nome do transmitente',
            )
            el-table-column(
              prop='dataOcupacaoAtual',
              label='Data da ocupação',
              :formatter='formatDate',
            )
            el-table-column(
              prop='area',
              label='Área',
              :formatter='formatArea',
            )
            el-table-column(
              prop='ocupantePrimitivo',
              label='Ocupante primitivo?',
              :formatter='formatOcupante',
            )
        app-display(
          :label="labelQualificacao.praticaCultutraEfetiva",
          :content="qualificacao.praticaCultutraEfetiva ? 'Sim' : 'Não'",
        )
        span.pessoas Lista de pessoas que acompanham o processo
        div(v-for="pessoa in pessoas")
          app-display(
            :content="pessoa.nomeRazaoSocial",
          )
</template>

<script>
import AppDisplay from './../AppDisplay'
import AppDivider from '@/components/AppDivider'
import utils from '@/utils/utils'
const { labelVisualizacaoProcesso, getArea } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  props: {
    qualificacao: {
      type: Object,
      required: false
    },
    tipo: {
      type: String,
      default: '-'
    },
    dataCadastro: {
      type: String,
      default: null
    },
    isBeneficiario: {
      type: Boolean,
      required: false,
      default: false
    },
    cadastroOriginal: {
      type: Object,
      required: true
    },
    pessoas: {
      type: Array,
      required: true
    },
    dataRetificacao: {
      type: String,
      default: null
    }
  },

  computed: {

    renda () {
      return getArea(this.qualificacao.renda)
    },

    getSituacao () {
      if ((Number(this.qualificacao.area)) <= 100 &&
        this.qualificacao.renda !== 'mais5' &&
        !this.qualificacao.cargoPublico &&
        !this.qualificacao.possuiImovelRuralTitulado &&
        this.qualificacao.ocupaImovel &&
        this.qualificacao.exploracaoAgricola) {
        return 'Apto'
      }
      return 'Não Apto'
    }
  },

  methods: {
    formatterDecimal (value) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    },

    formatDate (data) {
      return utils.formatDate(data, 'DD/MM/YYYY')
    },

    formatOcupante (row, column, prop) {
      return prop ? 'Sim' : 'Não'
    },

    formatArea (row, column, prop) {
      if (prop) {
        if (prop.tipoArea === 'LINHA') {
          return `${prop.area} linha(s)`
        }
        return `${prop.area} hectare(s)`
      }

      return ''
    }
  },

  data () {
    return {
      labelQualificacao: labelVisualizacaoProcesso.etapaQualificacao
    }
  }
}
</script>

<style lang="scss" scoped>
  .margem {
    margin-left: 6px;
  }
  .marginTop {
    padding-top: 15px;
  }
  .pessoas{
    font-weight: bold;
    font-size: 14px;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesQualificacaoRr.vue